// import * as Sentry from "@sentry/react";

// Sentry.init({
//   dsn: "https://9f9bf7bd8e4882c40c392eeaec91b51a@o4509197598457856.ingest.us.sentry.io/4509197600948224"
// });

import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css'
import App from './App.jsx'

import { Provider } from 'react-redux';
import { AppProvider as PolarisProvider } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';
import '@shopify/polaris/build/esm/styles.css';

import store from './redux/store';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <PolarisProvider i18n={enTranslations}>
      <Provider store={store}>
        <App />
      </Provider>
    </PolarisProvider>
  </React.StrictMode>
);
